<template>
  <div class="row col-md-12">
    <div class="form-group col-md-6">
      <label>Mã ticket:</label>
      <input type="text" class="form-control form-control-solid" :value="ticketId"
             placeholder="Mã ticket" disabled>
    </div>
    <div class="form-group col-md-6">
      <label>Danh mục:</label>
      <input type="text" class="form-control form-control-solid" :value="categoryLabel"
             placeholder="Danh mục" disabled>
    </div>
    <div class="form-group col-md-6">
      <label>Chi nhánh:</label>
      <input type="text" class="form-control form-control-solid" :value="branchName"
             placeholder="Chi nhánh" disabled>
    </div>
    <div class="form-group col-md-6">
      <label>Lớp học:</label>
      <input type="text" class="form-control form-control-solid" :value="className"
             placeholder="Lớp học" disabled>
    </div>
    <div class="form-group col-md-6">
      <label>Ngày nghỉ học:</label>
      <input type="text" class="form-control form-control-solid" :value="absenceLessonDateText"
             placeholder="Ngày nghỉ học" disabled>
    </div>
    <div class="form-group col-md-6">
      <label>Phân loại nghỉ:</label>
      <input type="text" class="form-control form-control-solid" :value="absenceTypeText"
             placeholder="Phân loại nghỉ" disabled>
    </div>
    <div class="form-group col-md-6">
      <label>Thời gian gửi video:</label>
      <input type="text" class="form-control form-control-solid" :value="sentAtText"
             placeholder="Thời gian gửi video" disabled>
    </div>
    <div class="form-group col-md-6">
      <label>Trạng thái học:</label>
      <input type="text" class="form-control form-control-solid" :value="learningStatusText"
             placeholder="Trạng thái học" disabled>
    </div>
    <div class="form-group col-md-6">
      <label>Bên xử lý:</label>
      <input type="text" class="form-control form-control-solid" :value="departmentLabel"
             placeholder="Bên xử lý" disabled>
    </div>
    <div class="form-group col-md-6" v-if="guaranteeUserVideo">
      <label>Link video:</label>
      <input @click="openLink" type="text" class="form-control form-control-solid" readonly
             :value="videoUrl" placeholder="Link video"
             style="cursor: pointer; color: #3699FF;">
    </div>
    <div class="col-md-12" v-else>
      <div class="border rounded p-3" style="border-color: #f56c6c !important; background-color: #fef0f0;">
        <p class="text-danger mb-1" style="font-size: 13px;">Hiện tại không tồn tại video học bù của buổi học này.</p>
        <p class="mb-0" style="font-size: 13px; color: #606266;">
          Vui lòng liên hệ với bộ phận Admin quản lý kho video và cập nhật link video
          <span
            style="color: #409eff; text-decoration: underline; cursor: pointer;"
            @click="retryCreateVideo"
          >{{ isRetrying ? 'đang tải...' : 'tại đây' }}</span>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { formatDateTimeAsia } from "@/core/filters";

export default {
  name: "VideoAbsenceTicketInfo",
  props: {
    ticketId: {
      type: [Number, String],
      default: null
    },
    categoryLabel: {
      type: String,
      default: ''
    },
    branchName: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    departmentLabel: {
      type: String,
      default: ''
    },
    guaranteeUserVideo: {
      type: Object,
      default: null
    },
    centerId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      isRetrying: false
    }
  },
  computed: {
    videoUrl() {
      if (!this.guaranteeUserVideo || !this.guaranteeUserVideo.short_id) return '';
      return `${this.centerId === 295 ? 'https://video.classup.edu.vn' : 'https://video.ieltsmentor.edu.vn'}/${this.guaranteeUserVideo.short_id}`;
    },
    sentAtText() {
      return this.guaranteeUserVideo && this.guaranteeUserVideo.sent_at
        ? formatDateTimeAsia(this.guaranteeUserVideo.sent_at)
        : 'Chưa gửi';
    },
    learningStatusText() {
      return this.guaranteeUserVideo && this.guaranteeUserVideo.learning_status
        ? this.guaranteeUserVideo.learning_status
        : 'Chưa có';
    },
    absenceLessonDateText() {
      return this.guaranteeUserVideo && this.guaranteeUserVideo.absence_lesson_date
        ? formatDateTimeAsia(this.guaranteeUserVideo.absence_lesson_date)
        : 'Chưa có';
    },
    absenceTypeText() {
      // Phân loại nghỉ lấy theo ticket nghỉ học gốc (category + val), giống logic màn ticket nghỉ học.
      if (!this.guaranteeUserVideo) return 'Chưa có';
      const type = String(this.guaranteeUserVideo.absence_type_category);
      const val = Number(this.guaranteeUserVideo.absence_val);
      if (type === '7') return 'Không phép';
      if (type === '16') return 'Có khiếu nại';
      if (val === 2) return 'Có phép';
      if (val === 0) return 'Không phép';
      return 'Chưa có';
    }
  },
  methods: {
    retryCreateVideo() {
      if (this.isRetrying || !this.ticketId) return;
      this.isRetrying = true;
      ApiService.post(`guarantee-videos/retry-for-ticket/${this.ticketId}`)
        .then(({ data }) => {
          if (data.error) {
            this.$notify({ type: 'warning', title: 'Thông báo', message: data.message || 'Không tìm thấy video phù hợp' });
          } else {
            this.$notify({ type: 'success', title: 'Thông báo', message: 'Tạo video học bù thành công' });
            this.$emit('video-created');
          }
        })
        .catch(() => {
          this.$notify({ type: 'warning', title: 'Thông báo', message: 'Không tìm thấy video phù hợp trong kho video' });
        })
        .finally(() => {
          this.isRetrying = false;
        });
    },
    openLink() {
      if (this.videoUrl) window.open(this.videoUrl, '_blank');
    }
  }
}
</script>
